import { FormControl, FormLabel, Typography } from '@mui/material';

type Props = {
  label?: string;
  value: string;
  required?: boolean;
  type?: string;
  fullWidth?: boolean;
  endAdornment?: any;
};

const ReadOnlyField = ({ label, type, value, required, fullWidth = true, endAdornment }: Props) => {
  return (
    <FormControl variant="standard" fullWidth={fullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Typography>{type === 'password' ? '********' : value}</Typography>
    </FormControl>
  );
};

export default ReadOnlyField;
